import React from 'react';
import { Box, Badge, Text } from '@wix/design-system';
export const CampaignData = _ref => {
  let {
    status,
    subject,
    sentOn,
    statistics
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    marginBottom: 1
  }, /*#__PURE__*/React.createElement(Badge, {
    size: "small",
    skin: "success"
  }, status)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, subject), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, "Sent on: ", sentOn)), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 5
  }, statistics.slice(0, 2).map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      key: `${label}_${value}`
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    }, value), /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, label));
  })));
};
//# sourceMappingURL=CampaignData.js.map